import React from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar, Button } from 'reactstrap';

const RouteDataToolbar = ({ fileUrl }) => (
  <ButtonToolbar className="pull-right">
    <div>
      <a href={fileUrl} target="_blank" rel="noopener noreferrer">
        <Button color="primary">
          <i className="fa fa-download" /> Descargar ZIP
        </Button>
      </a>
    </div>
  </ButtonToolbar>
);

RouteDataToolbar.propTypes = {
  fileUrl: PropTypes.string.isRequired,
};

export default RouteDataToolbar;
